// extracted by mini-css-extract-plugin
export default {"ConfirmationPop":"ConfirmationPop_ConfirmationPop__LuXHQ","modalBody":"ConfirmationPop_modalBody__1WqH-"};